class BaseConfig {
  isDev() {
    return process.env.NODE_ENV === "development";
  }
}

class ConfigDEV extends BaseConfig {
  API_URL = "https://api.dev.icankids.com.vn";
  API_BUS = "https://api-id.dev.icanx.vn";
  DOMAIN_ID = "https://im-id.icanx.vn";
  REDIRECT_URI = "https://promotion.dev.icankids.com.vn/auth";
  CLIENTID = "lyt-business_client1";
  CLIENTSECRET = "lyt-business-396d9cb4-33a7-42c2-9161-291da2bd2cc7-dev";
}

class ConfigStag extends BaseConfig {
  API_URL = "https://api-id.icanx.vn";
  API_BUS = "https://api-id.icanx.vn";
  DOMAIN_ID = "https://im-id.stag.icanx.vn";
  REDIRECT_URI = "https://promotion.icankids.com.vn/auth";
  CLIENTID = "lyt-business_web-11505";
  CLIENTSECRET = "lyt-business-8125ab49-b720-4ca6-a4c3-337c73cbfe92-stag";
}

class ConfigPROD extends BaseConfig {
  API_URL = "https://id.galaxyedu.io";
  API_BUS = "https://id.galaxyedu.io";
  DOMAIN_ID = "https://id.ican.vn";
  REDIRECT_URI = "https://promotion.icankids.com.vn/auth";
  CLIENTID = "lyt-business_web-ad44f";
  CLIENTSECRET = "lyt-business-8125ab49-b720-4ca6-a4c3-337c73cbfe92-prod";
}

const Config = 
  process.env.NODE_ENV === "development" ? new ConfigStag() : new ConfigStag() ;
// const config = process.env.NODE_ENV === 'development' ? new ConfigSTAG() : new ConfigPROD();

export default Config;
